import * as React from 'react';
import { injectIntl, Translate } from '../../localization/index';
import './PreLander.scss';
class PreLander extends React.PureComponent<{}> {
  state = {};
  render() {
    return (
      <div className="pre-lander-wrapper">
        <h1>
          <Translate
            id="pre-lander"
            defaultMessage="My Pre-Lander {theName}"
            values={{
              theName: 'test translations'
            }}
          />
        </h1>
      </div>
    );
  }
}

export default injectIntl(PreLander);
